// Mint-Mov-Phone2 khung "Cá nhân": hồ sơ, chấm công, nghỉ phép, đào tạo. Dữ liệu mẫu theo script board.
export const ME = { name: 'HÙNG', initial: 'H', role: 'Tài xế · 51C-482.17 · Tổ Vận tải', today: '22/Oct/2026', tripsToday: 3, month: 'T10', days: 17, leaveDays: 1, claimNote: '≤ 2 ngày đầu T11', leaveLeft: 9.5 } as const;

export type LeaveStatus = 'ok' | 'no' | 'wait';
export type Leave = { k: string; d: string; s: LeaveStatus };
export const LEAVES0: readonly Leave[] = [
  { k: 'Phép năm · 1 ngày', d: '09/Oct/2026 · PHONG', s: 'ok' },
  { k: 'Việc riêng · nửa ngày sáng', d: '02/Oct/2026 · PHONG', s: 'no' },
];
export const LEAVE_STATUS: Record<LeaveStatus, string> = { ok: 'Đã duyệt', no: 'Từ chối', wait: 'Chờ duyệt' };

export const LEAVE_TYPES = ['Phép năm', 'Việc riêng', 'Ốm'] as const;
export const LEAVE_DAYS = ['T6 23/Oct', 'T2 26/Oct', 'T3 27/Oct', 'T4 28/Oct', 'T5 29/Oct'] as const;

export function newLeave(type: string, day: string, why: string): Leave | null {
  if (!why.trim()) return null;
  return { k: `${type} · 1 ngày`, d: `${day} · MINHTQ`, s: 'wait' };
}

export type Course = { k: string; done: number; all: number; due: string; must: boolean; cert?: string };
export const COURSES: readonly Course[] = [
  { k: 'An toàn lái xe container 2026', done: 3, all: 5, due: '31/Oct/2026', must: true },
  { k: 'Chằng buộc và cắm điện cont lạnh', done: 4, all: 4, due: '', must: false, cert: 'Chứng chỉ nội bộ · hạn 12/Dec/2027' },
];

export function courseView(c: Course, extra: number) {
  const d = Math.min(c.all, c.done + extra);
  const fin = d >= c.all;
  return {
    pct: Math.round((d / c.all) * 100),
    fin,
    tag: fin ? 'Hoàn thành' : c.must ? 'Bắt buộc' : 'Tự chọn',
    desc: fin ? (c.cert ?? 'Đã hoàn thành') : `${d}/${c.all} bài · hạn ${c.due} (task TRN)`,
    next: d + 1,
  };
}

export function punchLabel(inAt: string | null, outAt: string | null) {
  return !inAt ? 'Chấm công vào' : !outAt ? 'Chấm công ra' : 'Đã chấm đủ hôm nay';
}
